var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001.4_PhoneSheet_Actions",
    transform: "translate(-952.000000, -143.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(952.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,3 L1.5,3 C1.224,3 1,3.224 1,3.5 L1,4.5 C1,4.776 1.224,5 1.5,5 L14.5,5 C14.777,5 15,4.776 15,4.5 L15,3.5 C15,3.224 14.777,3 14.5,3 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0 L2.5,0 C2.224,0 2,0.224 2,0.5 L2,1.5 C2,1.776 2.224,2 2.5,2 L13.5,2 C13.777,2 14,1.776 14,1.5 L14,0.5 C14,0.224 13.777,0 13.5,0 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,12 L5,12 C4.448,12 4,11.553 4,11 L4,8.5 C4,8.224 4.224,8 4.5,8 L5.5,8 C5.777,8 6,8.224 6,8.5 L6,9.5 C6,9.776 6.224,10 6.5,10 L9.5,10 C9.777,10 10,9.776 10,9.5 L10,8.5 C10,8.224 10.224,8 10.5,8 L11.5,8 C11.777,8 12,8.224 12,8.5 L12,11 C12,11.553 11.553,12 11,12 Z M0,6.5 L0,15.5 C0,15.776 0.224,16 0.5,16 L15.5,16 C15.777,16 16,15.776 16,15.5 L16,6.5 C16,6.224 15.777,6 15.5,6 L0.5,6 C0.224,6 0,6.224 0,6.5 Z",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.59336aab105cbe01fcd768dd202bbc69.svg";
export { ForwardRef as ReactComponent };